"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GenericPgFieldHandler", {
    enumerable: true,
    get: function() {
        return GenericPgFieldHandler;
    }
});
const _generic = require("~/db/field-handler/handlers/generic");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
let GenericPgFieldHandler = class GenericPgFieldHandler extends _generic.GenericFieldHandler {
    // region filter comparisons
    async filterLike(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    qb.where((subQb)=>{
                        subQb.where(knex.raw(`??::text = ''`, [
                            sourceField
                        ]));
                        subQb.orWhereNull(sourceField);
                    });
                } else {
                    qb.where(knex.raw('??::text ilike ?', [
                        sourceField,
                        `%${val}%`
                    ]));
                }
            }
        };
    }
    async filterNlike(args, rootArgs, _options) {
        const { sourceField } = args;
        let { val } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    // val is empty -> all values including NULL but empty strings
                    qb.whereNot(knex.raw(`??::text = ''`, [
                        sourceField
                    ]));
                    qb.orWhereNull(sourceField);
                } else {
                    val = val.startsWith('%') || val.endsWith('%') ? val : `%${val}%`;
                    qb.whereNot(knex.raw(`??::text ilike ?`, [
                        sourceField,
                        val
                    ]));
                    if (val !== '%%') {
                        // if value is not empty, empty or null should be included
                        qb.orWhere(knex.raw(`??::text != ''`, [
                            sourceField
                        ]));
                        qb.orWhereNull(sourceField);
                    } else {
                        // if value is empty, then only null is included
                        qb.orWhereNull(sourceField);
                    }
                }
            }
        };
    }
    async innerFilterAllAnyOf(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { filter, knex, column } = rootArgs;
        // Condition for filter, without negation
        const condition = (builder)=>{
            var _ref;
            var _column_dt;
            let items = (_ref = val == null ? void 0 : val.split(',')) != null ? _ref : [];
            if ([
                'enum',
                'set'
            ].includes((_column_dt = column.dt) == null ? void 0 : _column_dt.toLowerCase())) {
                items = items.map((item)=>item.trimEnd());
            }
            for(let i = 0; i < (items == null ? void 0 : items.length); i++){
                const bindings = [
                    sourceField,
                    `%,${items[i]},%`,
                    sourceField,
                    `%, ${items[i]},%`
                ];
                const sql = "((',' || ??::text || ',') ilike ? OR (',' || ??::text || ',') ilike ?)";
                if (i === 0) {
                    builder = builder.where(knex.raw(sql, bindings));
                } else {
                    if (filter.comparison_op === 'allof' || filter.comparison_op === 'nallof') {
                        builder = builder.andWhere(knex.raw(sql, bindings));
                    } else {
                        builder = builder.orWhere(knex.raw(sql, bindings));
                    }
                }
            }
        };
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (filter.comparison_op === 'allof' || filter.comparison_op === 'anyof') {
                    qb.where(condition);
                } else {
                    qb.whereNot(condition).orWhereNull(sourceField);
                }
            }
        };
    }
};
